"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoVerdict = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("../Base");
const NoVerdict = ({ colour = "currentcolor", size = 16, title }) => (react_1.default.createElement(Base_1.Base, { size: size, fill: colour, smooth: true, title: title },
    react_1.default.createElement("circle", { r: "2", cx: "8", cy: "8" })));
exports.NoVerdict = NoVerdict;
//# sourceMappingURL=NoVerdict.js.map